import { render, staticRenderFns } from "./ProductsSetup.vue?vue&type=template&id=e38df678&scoped=true&"
import script from "./ProductsSetup.vue?vue&type=script&lang=js&"
export * from "./ProductsSetup.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSetup.vue?vue&type=style&index=0&id=e38df678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38df678",
  null
  
)

export default component.exports